
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/casestudy",
      function () {
        return require("private-next-pages/solutions/casestudy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/casestudy"])
      });
    }
  